import { useTranslation } from "react-i18next";
import LegalContent from "./LegalContent";
import SEO from "../app/SEO";

export default function PrivacyPolicy() {
    const { t } = useTranslation("legal");
    const sections: any[] = t("policies.privacy.sections", { returnObjects: true });

    return (
        <>
            <SEO title={{ title: t("policies.privacy.fullTitle"), pageTitle: t("policies.privacy.fullTitle") }} canonicalPath="/legal/privacy-policy" />
            <LegalContent
                title={t("policies.privacy.title")}
                subtitle={t("policies.privacy.subtitle")}
                updated={t("lblUpdated", { date: t("policies.privacy.updated") })}
                sections={sections} />
        </>
    );
}